<template>
  <div class="template-list">
    <div :class="['template-content', isProgramEdit && 'program-edit']" v-if="!!tempList.length">
      <div v-for="item in tempList" :key="item.id" class="item">
        <div class="thumb">
          <el-popover placement="top" trigger="hover" :disabled="!isProgramEdit">
            <img class="origin-img" :src="item.img_url" />
            <img class="thumb-img" :src="item.thumb_url" slot="reference" />
          </el-popover>
          <div class="control-buttons">
            <template v-if="!isProgramEdit">
              <el-button type="info" size="mini" round @click="top(item.id)">置顶</el-button>
              <el-button type="info" size="mini" round @click="edit(item)">修改</el-button>
              <el-button type="info" size="mini" round @click="del(item.id)">删除</el-button>
            </template>
            <template v-else>
              <el-button type="info" size="mini" round @click="apply(item.id)">应用</el-button>
            </template>
          </div>
        </div>
        <div class="info">
          <div class="name">{{item.name}}</div>
          <div class="desc">{{ item.description }}</div>
        </div>
      </div>
      <div class="item loadMore" @click="loadMore" v-show="count !== tempList.length" style="cursor: pointer;">点击加载更多模板</div>
      <div class="item loadMore" v-show="count === tempList.length && !!count">已加载全部模板</div>
    </div>
    <div class="empty" v-else>
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateList',
  props: {
    tempList: {
      type: Array,
      default: () => []
    },
    count: {
      type: Number,
      default: 0
    },
    themeId: {
      type: Number,
      default: 0
    },
    isProgramEdit: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    updateTempData: { value: 'updateTempData', default: null }
  },
  methods: {
    top(id) {
      this.$http.post('/admin/template/stickyPost', {
        id,
        themeId: this.themeId,
        type: 0,
        group_ids: this.$cookies.get('group_ids')
      }, () => {
        this.$emit('refresh');
      })
    },
    edit(temp) {
      this.$emit('handleTempEdit', temp);
    },
    del(id) {
      this.$emit('handleTempDelete', id);
    },
    apply(id) {
      // todo 应用模板
      this.$http.post('/admin/template/getTemplateDetail', {
        id
      }, data => {
        this.updateTempData(data);
      })
    },
    loadMore() {
      // 当前页码
      const page = Math.ceil(this.tempList.length / 10);
      this.$emit('loadMore', page + 1, this.themeId);
    }
  }
}
</script>

<style lang="scss" scoped>
.template-list {
  width: 100%;
  .template-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .item {
      width: 240px;
      height: 170px;
      margin: 10px;
      background-color: rgba($color: #909399, $alpha: 0.3);
      .thumb {
        width: 220px;
        height: 125px;
        margin: 5px auto;
        position: relative;
        .thumb-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .control-buttons {
          display: none;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .thumb:hover {
        .control-buttons {
          display: flex;
        }
      }
      .info {
        text-align: center;
        div {
          overflow: hidden;
        }
      }
    }
    .loadMore {
      text-align: center;
      line-height: 170px;
    }
  }
  .program-edit {
    .item {
      width: 120px;
      height: 90px;
      .thumb {
        width: 120px;
        height: 58px;
        margin-top: 2px;
      }
      .info {
        font-size: 12px;
      }
    }
    .loadMore {
      font-size: 14px;
      height: 90px;
      line-height: 90px;
    }
  }
  .empty {
    height: 30px;
    line-height: 30px;
    padding: 20px 0;
    color: #909399;
  }
}
</style>

<style lang="scss">
.origin-img {
  width: 400px;
  height: auto;
  max-width: 400px;
  max-height: 300px;
}
</style>